import React, {useEffect} from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import SetAvatar from "./components/SetAvatar";
//import Controller from "./components/Controller";
import Chat from "./pages/Chat";
import ProductForm from "./components/ProductForm";
import Unboxing from './components/Unboxing';
import ProductsWrapper from './components/ProductsWrapper';
import Login from "./pages/Login";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Register from "./pages/Register";
import TraderBrand from './components/TraderBrand';
import RequestReset from "./pages/RequestReset";
import UserRequests from './components/UserRequests';
import AgentDashboard from './components/AgentDashboard';
import OrdersList from './components/OrdersList';
import SellerTerms from './components/SellerTerms';
import ContactEmails from './components/ContactEmails';
import Shop from './components/Shop';
import SubscriptionPage from './components/SubscriptionPage';
import PasswordReset from "./pages/PasswordReset";
import AnalyticsDashboard from './components/AnalyticsDashboard';
//import CategoryItems from './components/CategoryItems';
import { StateContext } from './context/StateContext';
import LiveDiscovery from "./pages/LiveDiscovery";
import Live from "./pages/Live";
import GoLiveControlPanel from "./pages/GoLiveControlPanel";
import ReplayFeed from "./pages/ReplayFeed";
import AdminManagement from "./pages/AdminManagement";

export default function App() {
       useEffect(() => {
    // Window Controls Overlay Polyfill
    if ('windowControlsOverlay' in navigator) {
      const updateTitlebarArea = (event) => {
        const { x, width, height } = event.titlebarAreaRect;
        document.documentElement.style.setProperty('--titlebar-area-height', `${height}px`);
        document.documentElement.style.setProperty('--titlebar-area-x', `${x}px`);
        document.documentElement.style.setProperty('--titlebar-area-width', `${width}px`);
      };

      navigator.windowControlsOverlay.addEventListener('geometrychange', updateTitlebarArea);

      // Initial call to set values
      updateTitlebarArea({ 
        titlebarAreaRect: navigator.windowControlsOverlay.getTitlebarAreaRect() 
      });

      // Cleanup
      return () => {
        navigator.windowControlsOverlay.removeEventListener('geometrychange', updateTitlebarArea);
      };
    }
  }, []);

  return (
    <HashRouter>
    <StateContext>
      <Routes>
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/setavatar" element={<SetAvatar />} />
        <Route path="/request" element={<RequestReset />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/resetin/:token" element={<PasswordReset />} />
        <Route path="/" element={<Chat />} />
        <Route path="/category/:slug" element={<ProductsWrapper />} />
        <Route path="/addproduct/:userId" element={<ProductForm />}/>
        <Route path="/userrequests/:userId" element={<UserRequests />}/>
        <Route path="/traderbrand/:userbrandId" element={<TraderBrand/>}/>
        <Route path="/items/:categoryName" element={<Chat />}/>
        <Route path="/unboxing" element={<Unboxing />} />
        <Route path="/orders/:userId" element={<OrdersList />} />
        <Route path="/chat/:userId" element={<Chat />} />
        <Route path="/agents/:userId" element={<AgentDashboard />} />
        <Route path="/terms&conditions/:userId" element={<SellerTerms />} />
        <Route path="/emails/:userId" element={<ContactEmails />} />
        <Route path="/manageadmins/:userId" element={<AdminManagement />} />
        <Route path="/subscription/:userId" element={<SubscriptionPage />} />
        <Route path="/insights/:userId" element={<AnalyticsDashboard />}/>
        <Route path="/shop/:contactId" element={<Shop />} /> 
        <Route path="/live-discovery" element={<LiveDiscovery />} />
        <Route path="/live/:sessionId" element={<Live />} />
        <Route path="/live" element={<Live />} />  {/* no id → Live.js itself redirects to /live-discovery */}
        <Route path="/golive" element={<GoLiveControlPanel />} />
        <Route path="/replays" element={<ReplayFeed />} />

      </Routes>
       </StateContext>
    </HashRouter>
  );
}


if ('serviceWorker' in navigator ){
  window.addEventListener ('load', ()=>{
    navigator.serviceWorker.register('/service-worker.js')
  })
}